import React from 'react';
import styles from './LayoutComponents.module.css';

export const Container = ({
  fill,
  className,
  children,
}: {
  fill: string;
  className?: string;
  children?: React.ReactNode;
}) => (
  <div
    className={`u-grid ${styles.container}${className ? ` ${className}` : ''}`}
    style={{ ['--fill']: fill || 'black' } as React.CSSProperties}
  >
    {children}
  </div>
);

export const Content = ({
  className,
  children,
}: {
  className?: string;
  children?: React.ReactNode;
}) => (
  <div className={`${styles.content}${className ? ` ${className}` : ''}`}>
    {children}
  </div>
);
